import { NgClass } from "@angular/common";
import { Component, OnInit } from "@angular/core";

import { MatButton } from "@angular/material/button";
import { RouterLink, RouterOutlet } from "@angular/router";
import { LoaderComponent } from "@components/loader/loader.component";
import { MainNavComponent } from "@components/main-nav/main-nav.component";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { debounceTime, fromEvent, Subject, Subscription, startWith, takeUntil } from "rxjs";
import { ImageUrlDirective } from "./directives";
import { ApiMessageService, AppStateService } from "./services";

@Component({
  selector: "fh-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  standalone: true,
  imports: [
    MainNavComponent,
    FlexLayoutModule,
    NgClass,
    MatButton,
    RouterLink,
    RouterOutlet,
    LoaderComponent,
    ImageUrlDirective,
  ],
})
export class AppComponent implements OnInit {
  resizeSubscription: Subscription | undefined;
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    public apiMessageService: ApiMessageService,
    private appStateService: AppStateService
  ) {}
  ngOnInit() {
    // Auth state now comes from the session cookie (via APP_INITIALIZER's
    // bootstrapSession() call and AuthGaurd's live checks), not localStorage — do not
    // clobber it here.
    this.resizeSubscription = fromEvent(window, "resize")
      .pipe(startWith(null), debounceTime(200), takeUntil(this.destroy$))
      .subscribe(() => {
        this.appStateService.windowSize$.next({
          innerHeight: window.innerHeight,
          innerWidth: window.innerWidth,
        });

        console.log(this.appStateService.windowSize$.value);

        this.appStateService.deviceType$.next(window.innerWidth < 768 ? "mobile" : "desktop");
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }
}
